import React, { useState } from 'react';
import Button from '../../components/common/Button';
import FormField from '../../components/common/FormField';
import { CompanyInfoDTO } from '../../services/apiClient';
import handleChange from '../../utils/formUtils/handleChange';

interface CompanyInfoFormProps {
  initialValues: CompanyInfoDTO;
  onSubmit: (data: CompanyInfoDTO) => void;
  onCancel: () => void;
}

const CompanyInfoForm: React.FC<CompanyInfoFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
}) => {
  const [formData, setFormData] = useState<CompanyInfoDTO>(initialValues);

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData); // Pass the updated data back to the parent
  };

  return (
    <form onSubmit={handleFormSubmit}>
      <div className="mb-4">
        <FormField
          id="name"
          label="Name"
          type="text"
          value={formData.name || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter name"
        />
        <FormField
          id="email"
          label="Email"
          type="email"
          value={formData.email || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter email"
        />
        <FormField
          id="phone"
          label="Phone"
          type="text"
          value={formData.phone || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter phone number"
        />
        <FormField
          id="address"
          label="Address"
          type="text"
          value={formData.address || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter address"
        />
        <FormField
          id="bank"
          label="Bank"
          type="text"
          value={formData.bank || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter bank"
        />
        <FormField
          id="accounttype"
          label="Account Type"
          type="text"
          value={formData.accountType || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter account type"
        />
        <FormField
          id="branchcode"
          label="Branch Code"
          type="text"
          value={formData.branchCode || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter branch code"
        />
        <FormField
          id="accountnumber"
          label="Account Number"
          type="text"
          value={formData.accountNumber || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter account number"
        />
        <FormField
          id="swiftcode"
          label="Swift Code"
          type="text"
          value={formData.swiftCode || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter swift code"
        />
        <FormField
          id="notes"
          label="Notes"
          type="textarea"
          value={formData.notes || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter notes"
        />
      </div>
      <div className="flex justify-end space-x-4">
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">Save</Button>
      </div>
    </form>
  );
};

export default CompanyInfoForm;
